import { render, staticRenderFns } from "./UserReplies.vue?vue&type=template&id=acaa1da4&"
import script from "./UserReplies.vue?vue&type=script&lang=js&"
export * from "./UserReplies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports